// extracted by mini-css-extract-plugin
module.exports = {"root":"TopBar_root__sAPtR","toolbar":"TopBar_toolbar__2l6Jo","logo":"TopBar_logo__2zPIY"};